module.exports = __webpack_public_path__ + "static/media/1010255.ffc2133e.jpg";